import React, { Component } from 'react';
import { render, unmountComponentAtNode as remove } from 'react-dom';
import PropTypes from 'prop-types';

import getAuth from '../../helpers/get-auth';
//import declOfNum from '../../helpers/decl';
import isBlankString from '../../helpers/is-blank-string';

import Input from '../input';
import RoundCheck from '../round-check';
import Checkbox from '../checkbox';
import UserPic from './user-pic';
import SettingsPhone from './settings-phone';
import Popup from '../popup';

class Profile extends Component {
  static = {
    hint: (
      <svg viewBox="0 0 26 26" width="26" height="26">
        <path d="M13 6.5c-.9 0-1.6.7-1.6 1.6s.7 1.6 1.6 1.6 1.6-.7 1.6-1.6c0-.9-.7-1.6-1.6-1.6zm0 4.9c-.9 0-1.6.7-1.6 1.6v4.9c0 .9.7 1.6 1.6 1.6s1.6-.7 1.6-1.6v-4.9c0-.9-.7-1.6-1.6-1.6zm0-11.4c-7.2 0-13 5.8-13 13s5.8 13 13 13 13-5.8 13-13-5.8-13-13-13zm0 23.6c-5.8 0-10.6-4.8-10.6-10.6s4.8-10.6 10.6-10.6 10.6 4.8 10.6 10.6-4.8 10.6-10.6 10.6z" />
      </svg>
    ),
  };

  static propTypes = {
    route: PropTypes.shape({
      user: PropTypes.string,
      edit: PropTypes.string,
      login: PropTypes.string,
      verify: PropTypes.string,
    }).isRequired,
  };

  state = {
    loading: true,
    data: false,
    key: 0,
    deleteAvatar: false,
    sendData: false,
    birthday: false,
    noBonus: false,
    hasEmpty: false,
  };

  componentDidMount() {
    this.loadData();

    setTimeout(() => {
      const { hasEmpty, data } = this.state;

      if (data.phone && hasEmpty) this.checkEmpty();
    }, 5000);
  }

  // Получаем данные
  loadData(isShowPopup = true) {
    const {
      route: { user },
    } = this.props;
    const { sendData } = this.state;
    //const self = this;

    let headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      headers.headers.authorization = getAuth();
    }

    fetch(user, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          if (sendData) {
            if (isShowPopup)
              this.showPopup('success', 'Ваши данные успешно сохранены.');
            this.setState({
              sendData: false,
              key: this.state.key + 1,
              data: json.data,
              oldData: json.data,
              noBonus: json.data.cinema.no_bonus,
              deleteAvatar: !json.data.avatar,
            });
          } else {
            this.setState({
              loading: false,
              data: json.data,
              birthday: json.data && json.data.birthday,
              oldData: json.data,
              noBonus: json.data.cinema.no_bonus,
              deleteAvatar: !json.data.avatar,
            });

            let data = json.data;

            if (
              (data && data.accept_rules === 0) ||
              !data.phone ||
              data.first_name === null ||
              (data && data.first_name.trim() === '') ||
              data.last_name === null ||
              (data && data.last_name.trim() === '') ||
              data.patronymic === null ||
              (data && data.patronymic.trim() === '') ||
              data.birthday === null ||
              data.gender === null ||
              data.email === null ||
              (data && data.email.trim() === '')
            ) {
              this.setState({
                hasEmpty: true,
              });
            } else {
              this.setState({
                hasEmpty: false,
              });
            }
          }
        } else if (json.status == 'error') {
          if (sendData) {
            this.setState({
              sendData: false,
            });
            this.showPopup('success', 'Ваши данные успешно сохранены.');
            location.reload();
          } else {
            this.setState({
              loading: false,
            });

            this.showPopup(
              'error',
              json.errors.message || 'Что-то пошло не так. Попробуйте еще раз.',
              () => {
                document.location.href = '/login';
              },
            );
          }
        }
      })
      .catch(error => {
        if (sendData) {
          this.setState({
            sendData: false,
          });
          this.showPopup('success', 'Ваши данные успешно сохранены.');
          location.reload();
        } else {
          this.setState({
            loading: false,
          });

          this.showPopup('error', 'Что-то пошло не так. Попробуйте еще раз.');
        }
      });
  }

  // Вывод имени
  getName = () => {
    const { data } = this.state;

    let name = 'Профиль';

    if (!isBlankString(data.name)) {
      let nameArr = data.name.replace(/(^\s*)|(\s*)$/g, '').split(' ');

      name = nameArr[0];

      if (nameArr.length > 1) {
        name = `${nameArr[0]} ${nameArr[1].charAt(0)}.`;
      }
    }

    return name;
  };

  // Изменения полей
  changeData = (val, name) => {
    let data = JSON.parse(JSON.stringify(this.state.data));
    let value = val;

    if (name == 'birthday') value = val.replace(/[^\d\.]/g, '');

    data[name] = value;
    this.setState({ data });
  };

  // Отмена настроек
  cancel = () => {
    const { key, oldData, wasSaved } = this.state;
    const data = JSON.parse(JSON.stringify(oldData));

    this.setState({
      key: key + 1,
      data,
      deleteAvatar: !data.avatar,
    });
  };

  // Готовим данные на отправку
  prepareData() {
    const data = $(this.form).serializeArray();

    if (!data) return data;

    let formData = new FormData();

    data.forEach(item => {
      if (!isBlankString(item.value)) {
        formData.append(item.name, item.value);
      }
    });

    let photoInput = $(this.form).find('input[name="photo"]')[0];

    if (photoInput && photoInput.files.length) {
      formData.append('photo', photoInput.files[0]);
    }

    return formData;
  }

  // Сохранить настройки
  confirm = (e, isSaveAvatar = false, isShowPopup = true) => {
    e.preventDefault();

    const { data, deleteAvatar } = this.state;
    const {
      route: { edit },
    } = this.props;

    let formData = this.prepareData();

    if (deleteAvatar || isSaveAvatar) {
      formData.append('photo_del', true);
    }

    // for (var pair of formData.entries()) {
    // 	console.log(pair[0]+ ', ' + pair[1]);
    // }

    let headers = {
      method: 'POST',
      body: formData,
      headers: {},
    };

    if (process.env.NODE_ENV != 'dev') {
      headers.credentials = 'include';
    } else {
      headers.headers.authorization = getAuth();
    }

    this.setState({
      sendData: true,
    });

    // send data
    fetch(edit, headers)
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.loadData(isShowPopup);
        } else if (json.status == 'error') {
          this.setState({
            sendData: false,
          });

          this.showPopup(
            'error',
            json.errors.message || 'Что-то пошло не так. Попробуйте еще раз.',
          );
        }
      })
      .catch(error => {
        this.setState({
          sendData: false,
        });

        this.showPopup(
          'error',
          `Что-то пошло не так: ${error}. Попробуйте еще раз.`,
        );
      });
    // }, 500);
  };

  // Вывод попапа с результатом
  showPopup(status, message, func) {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = 'mfp-anim';
        },
        open: function() {
          render(
            <Popup
              type="alert"
              status={status}
              title={status == 'success' ? 'Отлично!' : 'Ошибка'}
              message={message}
              button="Назад в профиль"
              func={func}
            />,
            $('#popup')[0],
          );
        },
        close: function() {
          remove($('#popup')[0]);
        },
      },
    });
  }

  // Проверяем пустые поля
  checkEmpty() {
    const { data } = this.state;

    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = 'mfp-anim';
        },
        open: function() {
          render(<Popup type="verify" data={data} />, $('#popup')[0]);
        },
        close: () => {
          this.setState({ loading: true, hasEmpty: false });
          remove($('#popup')[0]);
          this.loadData();
          this.changeData();
        },
      },
    });
  }

  // Попап со сменой пароля
  newPass = () => {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },
      removalDelay: 250,
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = 'mfp-anim';
        },
        open: function() {
          render(<Popup type="new-pass" />, $('#popup')[0]);
        },
        close: function() {
          remove($('#popup')[0]);
        },
      },
    });
  };

  /**
   * Проверяем входит содержится ли  значение в массиве
   * @param needle
   * @param haystack
   * @returns {Boolean}
   */
  contains = (needle, haystack) => {
    return haystack.includes(needle);
  };

  /**
   * Нужно ли показывать ссылку на активацию физических карт
   * @returns {Boolean}
   */
  checkShowActiveCard = () => {
    const {data} = this.state;

    return data && data.user_rest && data.user_rest.region_id && !this.contains(data.user_rest.region_id, [2, 5]);
  };

  render() {
    const { hint } = this.static;
    const {
      key,
      loading,
      data,
      sendData,
      birthday,
      noBonus,
      hasEmpty,
    } = this.state;
    const { route } = this.props;

    let btnClasses = ['btn'];

    if (sendData) btnClasses.push('btn--loading');
    if (loading || !data) return null;

    const formUser = (
      <div className="form__user">
        <div className="user">
          <UserPic
            avatar={data.avatar}
            defaultAvatar={data.default_avatar}
            name="photo"
            disable={!data.phone}
            handleDelete={del => this.setState({ deleteAvatar: del })}
            saveData={this.confirm}
          />
          <div className="user__capture">
            <p className="user__name">{this.getName()}</p>
            {noBonus === true ? null : (
              <p className="user__bonuses balance-count">
                <span>{data.balance || 0}</span>
              </p>
            )}
            <div className="container-btn-exit">
              <a
                className="btn btn--outline btn--white btn--exit"
                href="/?logout=yes"
              >
                Выход
                <svg width="20" height="20" style={{ marginLeft: '8px' }}>
                  <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-logout"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    );

    if (!data.phone) {
      return (
        <div className="page-section form">
          {formUser}
          <div className="form__fieldset">
            <SettingsPhone route={route} />
            <div className="locked-block locked-block--top">
              <div className="locked-block__content">
                <div className="page-section__block">
                  <div className="page-section__title">
                    <h2 className="heading heading--1">
                      <div className="heading__hint-wrap">
                        Личная информация
                        <div className="hint">
                          <div className="hint__sign">{hint}</div>
                          <div className="hint__popover">
                            <p>
                              Мы собираем персональную информацию, чтобы
                              предоставлять актуальные для вас и вашего
                              города&nbsp;
                              <a href="/news" target="_blank">
                                скидки и акции
                              </a>
                              .
                            </p>
                          </div>
                        </div>
                      </div>
                    </h2>
                  </div>
                  <div className="inp-group inp-group--2 profile-form">
                    <div className="row">
                      <div className="inp-group__case full-case">
                        <Input
                          disable
                          label="Фамилия"
                          name="last_name"
                          placeholder="Фамилия"
                          value={data.last_name || ''}
                          lang="rus"
                          onChange={this.changeData}
                          required
                        />
                      </div>
                      <div className="inp-group__case full-case">
                        <Input
                          disable
                          label="Имя"
                          name="first_name"
                          placeholder="Имя"
                          value={data.first_name || ''}
                          lang="rus"
                          onChange={this.changeData}
                          required
                        />
                      </div>
                      <div className="inp-group__case full-case">
                        <Input
                          disable
                          label="Отчество"
                          name="patronymic"
                          placeholder="Отчество"
                          value={data.patronymic || ''}
                          lang="rus"
                          onChange={this.changeData}
                          required
                        />
                      </div>
                      <div className="inp-group__case full-case">
                        <div className="wrap wrap--day">
                          <Input
                            disable
                            date
                            label="Дата рождения"
                            name="birthday"
                            placeholder="дд.мм.гггг"
                            value={data.birthday || ''}
                            onChange={this.changeData}
                            required
                          />
                        </div>
                        <div className="wrap wrap--gender">
                          <div className="round-checks">
                            <RoundCheck
                              checked={data.gender == 0}
                              icon="female"
                              label="Женский"
                              name="gender"
                              value={0}
                              onChange={this.changeData}
                            />
                            <RoundCheck
                              checked={data.gender == 1}
                              icon="male"
                              label="Мужской"
                              name="gender"
                              value={1}
                              onChange={this.changeData}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="inp-group__case">
                        <Input
                          disable
                          label="Город"
                          name="city"
                          value={data.city || ''}
                          onChange={this.changeData}
                          required
                        />
                      </div>
                      <div className="inp-group__case">
                        <Input
                          disable
                          label="Район"
                          name="district"
                          value={data.district || ''}
                          onChange={this.changeData}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="locked-block__message">
                <p>
                  Подтвердите свой номер телефона для&nbsp;доступа
                  к&nbsp;профилю
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <form
        key={key}
        className="page-section form"
        ref={node => (this.form = node)}
        onSubmit={this.confirm}
      >
        {formUser}
        <div className="form__fieldset">
          {noBonus === true ? null : (
            <div className="page-section__block">
              {/* <div className="page-section__title">
                <h2 className="heading heading--1">Настройки</h2>
              </div> */}
              {/* <ProfileCard
                card={data.card}
                percent={data.card_percent}
                step={data.step_sum}
                cardImg={data.card_img}
              /> */}
            </div>
          )}
          <div className="page-section__block">
            <div className="page-section__title">
              <h2 className="heading heading--1">
                <div className="heading__hint-wrap">
                  Данные для входа
                  <div className="hint">
                    <div className="hint__sign">{hint}</div>
                    <div className="hint__popover">
                      <p>Обновляйте данные, чтобы не потерять доступ к профилю.</p>
                    </div>
                  </div>
                </div>
              </h2>
            </div>
            <div className="inp-group inp-group--2">
              <div className="row">
                <div className="inp-group__case">
                  <Input
                    disable
                    label="Номер телефона"
                    phone
                    value={data.phone || ''}
                    required
                  />
                </div>
                <div className="inp-group__case">
                  <Input
                    label="E-mail"
                    name="email"
                    placeholder="Укажите e-mail"
                    value={data.email || ''}
                    onChange={this.changeData}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="inp-group inp-group--2">
              <div className="row">
                <div className="inp-group__case">
                  <button
                    type="button"
                    className="btn btn--outline"
                    onClick={() => this.newPass()}
                  >
                    Изменить пароль
                  </button>
                </div>
                { this.checkShowActiveCard() ? (<div className="inp-group__case inp-group__case-text">
                  Привязать бонусную карту вы можете в разделе&nbsp;
                  <a href="/profile/bonuses/">Бонусы</a>
                </div>) : null}
              </div>
            </div>
          </div>
          <div className="page-section__block">
            <div className="page-section__title">
              <h2 className="heading heading--1">
                <div className="heading__hint-wrap">
                  Личная информация
                  <div className="hint">
                    <div className="hint__sign">{hint}</div>
                    <div className="hint__popover">
                      <p>
                        Мы собираем персональную информацию, чтобы предоставлять
                        актуальные для вас и вашего города&nbsp;
                        <a href="/news" target="_blank">
                          скидки и акции
                        </a>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </h2>
            </div>
            <div className="inp-group inp-group--2 profile-form">
              <div className="row">
                <div className="inp-group__case full-case">
                  <Input
                    label="Фамилия"
                    name="last_name"
                    placeholder="Фамилия"
                    value={data.last_name || ''}
                    lang="rus"
                    onChange={this.changeData}
                    required
                  />
                </div>
                <div className="inp-group__case full-case">
                  <Input
                    label="Имя"
                    name="first_name"
                    placeholder="Имя"
                    value={data.first_name || ''}
                    lang="rus"
                    onChange={this.changeData}
                    required
                  />
                </div>
                <div className="inp-group__case full-case">
                  <Input
                    label="Отчество"
                    name="patronymic"
                    placeholder="Отчество"
                    value={data.patronymic || ''}
                    lang="rus"
                    onChange={this.changeData}
                    required
                  />
                </div>
                <div className="inp-group__case full-case">
                  <div className="wrap wrap--day">
                    <Input
                      disable={!!birthday}
                      date
                      label="Дата рождения"
                      name="birthday"
                      placeholder="дд.мм.гггг"
                      value={data.birthday || ''}
                      onChange={this.changeData}
                      required
                    />
                  </div>
                  <div className="wrap wrap--gender">
                    <div className="round-checks">
                      <RoundCheck
                        checked={data.gender == 0}
                        icon="female"
                        label="Женский"
                        name="gender"
                        value={0}
                        onChange={this.changeData}
                      />
                      <RoundCheck
                        checked={data.gender == 1}
                        icon="male"
                        label="Мужской"
                        name="gender"
                        value={1}
                        onChange={this.changeData}
                      />
                    </div>
                  </div>
                </div>
                <div className="inp-group__case full-case">
                  <Checkbox
                    checked={data.accept_rules == 1}
                    name="accept_rules"
                    value={data.accept_rules}
                    label={
                      <p>
                        Согласие на&nbsp;обработку{' '}
                        <a
                          href={data.pd}
                          target="_blank"
                          className="link"
                        >
                          персональных&nbsp;данных
                        </a>
                      </p>
                    }
                    disabled={data.accept_rules == 1}
                    onChange={this.changeData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form__buttons">
          <div className="wrap">
            <button className={btnClasses.join(' ')} type="submit">
              Сохранить изменения
            </button>
            {sendData ? null : (
              <button
                className="btn btn--outline"
                type="button"
                onClick={this.cancel}
              >
                Отменить изменения
              </button>
            )}
          </div>
        </div>
      </form>
    );

    // if (data.phone) {
    // } else {
    // 	return (
    // 		<div className="page-section form">
    // 			<div className="form__user">
    // 				<div className="user">
    // 					<UserPic
    // 						avatar={data.avatar}
    // 						defaultAvatar={data.default_avatar}
    // 						name="photo"
    // 						handleDelete={(del) => this.setState({ deleteAvatar: del })}
    // 					/>
    // 					<div className="user__capture">
    // 						<p className="user__name">{this.getName()}</p>
    // 						<p className="user__bonuses">{`${data.balance || 0} ${declOfNum(data.balance || 0, ['балл', 'балла', 'баллов'])}`}</p>
    // 					</div>
    // 				</div>
    // 			</div>
    // 			<div className="form__fieldset">
    // 				<div className="page-section__block">
    // 					<div className="page-section__title">
    // 						<h2 className="heading heading--1">Настройки</h2>
    // 					</div>
    // 				</div>
    // 			</div>
    // 		</div>
    // 	);
    // }
  }
}

export default Profile;
